import { Container, Typography, Grid, Box, Paper } from '@mui/material'
import {
  SessionManager,
  SimplifiedCertificateSelection,
  LoginSection,
  DashboardCard,
} from '../components'
import { StoredDocumentSigning } from '../components/dashboard/StoredDocumentSigning'
import { useCertificateContext } from '../providers'
import { Link } from 'react-router-dom'
import { CONTAINER_MAX_WIDTH } from '../constants'

export function DashBoard() {
  const { selectedCertificate } = useCertificateContext()

  return (
    <Container maxWidth={CONTAINER_MAX_WIDTH} sx={{ py: 3 }}>
      {/* Header */}
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography
          variant="h3"
          component="h1"
          gutterBottom
          sx={{
            fontWeight: 'bold',
            color: 'primary.main',
            mb: 1,
          }}
        >
          İmzalama Kontrol Paneli
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ mb: 3 }}>
          Dijital imzalama işlemlerinizi kolayca yönetin
        </Typography>
      </Box>

      <Paper sx={{ p: 2, mb: 4 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 2,
            width: '100%',
          }}
        >
          <Link to="/team-settings">Takım Ayarları</Link>
          <Link to="/documents-management">Evrak Yönetimi</Link>
        </Box>
      </Paper>

      {/* Dashboard Grid */}
      <Grid container spacing={3}>
        {/* Session Management Card */}
        <Grid item xs={12} md={6}>
          <DashboardCard
            title="Oturum Yönetimi"
            subtitle="Aktif bağlantıları görüntüleyin ve yönetin"
            headerColor="primary"
          >
            <SessionManager />
          </DashboardCard>
        </Grid>

        {/* Certificate Selection Card */}
        <Grid item xs={12} md={6}>
          <DashboardCard
            title="Sertifika Seçimi"
            subtitle="İmzalama için kullanılacak sertifikayı seçin"
            headerColor="secondary"
          >
            <SimplifiedCertificateSelection />
          </DashboardCard>
        </Grid>

        {/* Login Section Card */}
        <Grid item xs={12} md={6}>
          <DashboardCard
            title="UYAP Girişi"
            subtitle="UYAP sistemine güvenli giriş yapın"
            headerColor="success"
          >
            <LoginSection />
          </DashboardCard>
        </Grid>

        {/* Document Signing Card */}
        <Grid item xs={12} md={6}>
          <DashboardCard
            title="Evrak Yönetimi ve İmzalama"
            subtitle="Evraklarınızı yükleyin, imzalayın ve yönetin"
            headerColor="warning"
          >
            <StoredDocumentSigning />
          </DashboardCard>
        </Grid>
      </Grid>

      {/* Status Bar */}
      <Box
        sx={{
          mt: 4,
          p: 2,
          bgcolor: 'white',
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Typography variant="body2" color="text.secondary" align="center">
          {selectedCertificate
            ? `Seçili Sertifika: ${selectedCertificate.cert.commonName}`
            : 'Henüz sertifika seçilmedi'}
        </Typography>
      </Box>
    </Container>
  )
}
